import { Box, Breadcrumbs, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { StyledInput } from "../../ui/StyledInput";
import { Card } from "../../ui/Card";
import { StyledButton } from "../../ui/StyledButton";

const ChangePassword = () => {
  return (
    <>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/settings">
            <Typography color="text.primary" fontWeight={600}>
              Settings
            </Typography>
          </Link>
          <Typography color="text.primary">Company</Typography>
          <Typography color="text.primary">Change Password</Typography>
        </Breadcrumbs>
      </Box>

      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        width={"100%"}
      >
        <Card
          style={{
            width: "100%",
          }}
        >
          <Stack justifyContent={"center"} alignItems={"center"} gap={"20px"}>
            <Typography fontWeight={"500"}>Change Password</Typography>
            <div>
              <Typography fontSize={12}>Old Password</Typography>
              <StyledInput fullWidth />
            </div>
            <div>
              <Typography fontSize={12}>New Password</Typography>
              <StyledInput fullWidth />
            </div>
            <div>
              <Typography fontSize={12}>Confirm Password</Typography>
              <StyledInput fullWidth />
            </div>

            <div>
              <StyledButton variant="contained">Update</StyledButton>
            </div>
          </Stack>
        </Card>
      </Stack>
    </>
  );
};

export default ChangePassword;
